import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign, faHashtag, faPercentage, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        tipo_mp: '',
        categoria: '',
        codigo: '',
        nombre: '',
        codigo_siesa: '',
        id_tipo_unidad: '',
        valor_unitario: '',
        valor_compra: '',
        iva: '',
        valor_real: '',
        valor_vendido: '',
        utilidad: '',
        errores: [],
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
        this.Calcular();
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }

    Calcular = () =>{
        var valor_unitario = document.getElementById('valor_compra').value;
        var iva = document.getElementById('iva').value;
        var utilidad = document.getElementById('utilidad').value;
        var total1 = 0;
        var total2 = 0;
        var total = 0;
        if(valor_unitario!='' || valor_unitario!=0){
            if(iva!='' || iva!=0){
                total1 = valor_unitario * (iva/100);  
                console.log(valor_unitario+ ' total1 '+total1);   
            }
            if(utilidad!='' || utilidad!=0){
                total2 = (parseFloat(valor_unitario) + parseFloat(total1)) * ((utilidad/100)+1);
                console.log('total2 '+total2);
            }
            total = parseFloat(total2);
        }
        this.setState({ valor_unitario: total, valor_real: total })
        document.getElementById('valor_unitario').value = total;
        document.getElementById('valor_real').value = total;
        console.log(total);
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { tipo_mp, codigo, nombre, codigo_siesa, id_tipo_unidad, valor_unitario, valor_compra, iva, valor_real, valor_vendido, utilidad,categoria } = this.state;
        var errores = [];
        if (!categoria) { errores.push("error_categoria"); }
        if (!tipo_mp) { errores.push("error_tipo_mp"); }
        if (!codigo) { errores.push("error_codigo"); }
        if (!nombre) { errores.push("error_nombre"); }
        if (!codigo_siesa) { errores.push("error_codigo_siesa"); }
        if (!id_tipo_unidad) { errores.push("error_id_tipo_unidad"); }
        if (!valor_unitario) { errores.push("error_valor_unitario"); }
        if (!valor_compra) { errores.push("error_valor_compra"); }
        if (!iva) { errores.push("error_iva"); }
        if (!valor_real) { errores.push("error_valor_real"); }
        if (!utilidad) { errores.push("error_utilidad"); }
        console.log(errores.length);
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        var datosEnviar = {
            tipo_mp: tipo_mp,
            codigo: codigo,
            nombre: nombre,
            codigo_siesa: codigo_siesa,
            id_tipo_unidad: id_tipo_unidad,
            valor_unitario: valor_unitario,
            valor_compra: valor_compra,
            iva: iva,
            valor_real: valor_real,
            valor_vendido: valor_vendido,
            utilidad: utilidad,
            categoria:categoria
        }
        Swal.showLoading();
        authAxios.post("materiales/registrar", datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Materiales!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterMateriales");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Materiales!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    render() {
        const { tipo_mp, codigo, nombre, codigo_siesa, id_tipo_unidad, valor_unitario, valor_compra, iva, valor_real, utilidad, categoria } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRO DE MATERIALES</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                            <div className="col-md-2">
                                                    <label htmlFor="categoria">Categoria</label>
                                                    <select name="categoria"
                                                        id="categoria"
                                                        className={((this.verificarError("error_categoria")) ? "is-invalid" : "") + " form-select form-select-sm"} value={categoria}  onChange={this.cambioValor}>
                                                        <option value="">Seleccione la categoria</option>
                                                        <option value="1">LUMINARIA</option>
                                                        <option value="2">CABLE</option>
                                                        <option value="3">POSTES</option>
                                                        <option value="4">HERAJERIA + ALL</option>
                                                        <option value="5">TRANSFORMADOR</option>
                                                        <option value="6">MANO DE OBRA</option>
                                                        <option value="7">TRANSPORTE</option>
                                                        <option value="8">EQUIPO</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="tipo_mp">Tipo MP</label>
                                                    <select name="tipo_mp"
                                                        id="tipo_mp"
                                                        className={((this.verificarError("error_tipo_mp")) ? "is-invalid" : "") + " form-select form-select-sm"} value={tipo_mp}  onChange={this.cambioValor}>
                                                        <option value="">Seleccione el tipo</option>
                                                        <option value="MAT">Material (MAT)</option>
                                                        <option value="MO">Mano Obra (MO)</option>
                                                        <option value="EQP">Equipo (EQP)</option>
                                                        <option value="TRA">Transporte (TRA)</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="codigo">Código</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_codigo")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="codigo" id="codigo" value={codigo} placeholder="Código" aria-describedby="helpId" onChange={this.cambioValor} />
                                                        <small id="helpId" className="invalid-feedback">Digite el Código</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="nombre" id="nombre" value={nombre} placeholder="Nombre" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Material</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="codigo_siesa">Código Siesa</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_codigo_siesa")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="codigo_siesa" id="codigo_siesa" value={codigo_siesa} placeholder="Código Siesa" aria-describedby="helpId" onChange={this.cambioValor} />
                                                        <small id="helpId" className="invalid-feedback">Digite el Código Siesa</small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="id_tipo_unidad">Unidad</label>
                                                    <select name="id_tipo_unidad" id="id_tipo_unidad"
                                                        className={((this.verificarError("error_id_tipo_unidad")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione la Unidad</option>
                                                        <option value="1">Global (GLB)</option>
                                                        <option value="2">Metros (M)</option>
                                                        <option value="3">Rollo</option>
                                                        <option value="4">Unidad (UND)</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Unidad</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="valor_compra">Valor Compra</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input onChange={this.cambioValor} style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_valor_compra")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="valor_compra" id="valor_compra" value={valor_compra} placeholder="Valor Compra" aria-describedby="helpId" />
                                                        <small id="helpId" className="invalid-feedback">Digite el Valor Compra</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="iva">I.V.A.</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_iva")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="iva" id="iva" value={iva} placeholder="I.V.A." aria-describedby="helpId" onChange={this.cambioValor} />
                                                        <small id="helpId" className="invalid-feedback">Digite el I.V.A.</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="utilidad">Utilidad</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faPercentage} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="utilidad" id="utilidad"
                                                            className={((this.verificarError("error_utilidad")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Utilidad" aria-describedby="helpId"
                                                            value={utilidad} onChange={this.cambioValor}
                                                        />
                                                        <small id="helpId" className="invalid-feedback">Digite la Utilidad</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="valor_unitario">Valor Unitario</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_valor_unitario")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="valor_unitario" id="valor_unitario" value={valor_unitario} placeholder="Valor Unitario" aria-describedby="helpId" onChange={this.cambioValor} />
                                                        <small id="helpId" className="invalid-feedback">Digite el Valor Unitario</small>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="valor_real">Valor Real</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_valor_real")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="valor_real" id="valor_real" value={valor_real} placeholder="Valor Real" aria-describedby="helpId" onChange={this.cambioValor} />
                                                        <small id="helpId" className="invalid-feedback">Digite el Valor Real</small>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Material</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterMateriales"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;